<script setup>
import {onMounted, provide, ref} from "vue";
import constants from "@/constants/constants";
import dashboardService from "@/services/dashboard.service";
import TrackersListModal from "@/components/trackers/TrackersListModal.vue";

const chartData = ref(null);
const trackersListModal = ref(null);

onMounted(() => {
    getChartData();
});

async function getChartData() {
    const {data} = await dashboardService.getChartData("TrackersRelatedToMe");
    chartData.value = data;
}

function getTrackersMethod(pageParams) {
    return dashboardService.getChartTrackersList("TrackersRelatedToMe", null, null, pageParams);
}

provide('getTrackersIndexList', getTrackersMethod);
</script>

<template>
    <div>
        <div v-if="chartData !== null">
            <div class="title">
                Requests/POCs Related To Me
            </div>

            <table>
                <thead>
                    <tr>
                        <th>Trackers</th>
                        <th>Type</th>
                        <th>BA</th>
                        <th>Startups</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="tracker in chartData.trackers" :key="tracker.id">
                        <td><a :href="`/trackers/${tracker.id}`" target="_blank">{{ tracker.name }}</a></td>
                        <td>{{ tracker.type }}</td>
                        <td>{{ tracker.folder }}</td>
                        <td>{{ tracker.startups }}</td>
                    </tr>
                </tbody>
            </table>

            <a
                v-if="chartData.has_more"
                class="link"
                @click="trackersListModal.open()"
            >More trackers</a>

            <TrackersListModal
                ref="trackersListModal"
                :read-only="true"
            />
        </div>

        <div v-else class="d-flex justify-content-center">
            <b-spinner :style="{'color':constants.spinnerColor}"></b-spinner>
        </div>
    </div>
</template>

<style scoped>
    .title {
        font-size: 18px;
        margin-bottom: 20px;
    }

    table {
        width: 100%;
        margin-bottom: 20px;

        td {
            border: 1px solid black;
            padding: 5px;
        }

        tr:nth-child(even) {
            background-color: #f2f2f2;
        }
    }
</style>
